import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Per-page SEO: unique title, meta description, canonical + Open Graph/Twitter tags.
export function Seo({ title, description, canonical, image, type = "website", noindex = false }) {
  useEffect(() => {
    const fullTitle = title || "Mashiniya";
    const canon = canonical || (window.location.origin + window.location.pathname);
    document.title = fullTitle;
    upsertMeta("name", "description", description || "");
    upsertMeta("name", "robots", noindex ? "noindex,follow" : "index,follow");
    upsertLink("canonical", canon);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description || "");
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", canon);
    if (image) upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description || "");
    if (image) upsertMeta("name", "twitter:image", image);
  }, [title, description, canonical, image, type, noindex]);
  return null;
}
